module.exports = __webpack_public_path__ + "img/arrow_back.31899507.png";